import React from 'react'
import styled from 'styled-components'
import { PreloadLine } from '@rst/ui-ts'

const PreloaderSubHeader = () => {
	return (
		<Wrapper>
			<Main>
				<Social>
					{Array.from({ length: 4 }).map((_, i) => (
						<Item key={i} />
					))}
				</Social>
				<div>
					<Map>
						<Item />
						<Text />
					</Map>
					<Phone>
						<Item />
						<Text />
						<Point />
						<Text />
					</Phone>
				</div>
			</Main>
		</Wrapper>
	)
}

export { PreloaderSubHeader }

const Item = styled(PreloadLine)`
	width: 16px;
	height: 16px;
`

const Text = styled(PreloadLine)``

const Wrapper = styled.div`
	height: 36px;
	display: flex;
	justify-content: center;
`
const Main = styled.div`
	width: 1060px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	& > :nth-child(2) {
		display: flex;
	}
`

const Social = styled.div`
	display: flex;
	& > :not(:last-child) {
		margin-right: 20px;
	}
`

const Map = styled.div`
	display: flex;
	align-items: center;
	margin-right: 50px;
	${Item} {
		margin-right: 10px;
	}
	${Text} {
		width: 350px;
		height: 14px;
	}
`

const Phone = styled.div`
	display: flex;
	align-items: center;
	${Item} {
		margin-right: 10px;
	}
	& > :nth-child(2) {
		width: 120px;
		height: 14px;
	}
	& > :nth-child(4) {
		height: 14px;
		width: 115px;
	}
`
const Point = styled(PreloadLine)`
	width: 5px;
	height: 5px;
	margin: 0 10px;
`
